import { DatePickerDesignTokens } from '@primeuix/themes/types/datepicker';
import {variablesPreset} from './variables.preset';

export const datePickerPreset: DatePickerDesignTokens = {
  selectMonth: {
    padding: '0',
    hoverBackground: '$white'
  },
  selectYear: {
    padding: '0',
    hoverBackground: '$white'
  },
  date:{
    selectedBackground: 'transparent',
    padding: '0',
    hoverBackground: variablesPreset['primary-turquoise'],
    hoverColor: variablesPreset['white'],
    selectedColor: variablesPreset['primary-green']
  },
  inputIcon: {
    color : 'transparent'
  },
  panel: {
    padding : '0',
  },
  weekDay: {
    padding: '0',
    fontWeight: '900'
  }

}
